import React from "react";

export const ShipmentDetailContext = React.createContext(null);

export const useShipmentDetailContext = () => {
    const context = React.useContext(ShipmentDetailContext);

    if (!context) throw new Error("Shipment Detail Context not provided!");

    return context;
};